<template>
  <v-item-group class="pb-7">
    <v-row class="pb-9">
      <v-col cols="12">
        <p class="quotation-title black--text font-weight-bold">
          {{ title }}
        </p>
      </v-col>
      <v-col
        v-for="(item, key) of listActiveModality"
        :key="key"
        cols="12"
        sm="5"
        md="3"
        class="pr-5 pb-5 d-flex justify-center justify-sm-start"
      >
        <QuotationCard
          @click="selectedItem(item)"
          :name="item.nome"
          :background="item.imagem"
          :class="{ 'base-card-active': findActiveItem(item) }"
        />
      </v-col>
    </v-row>
    <v-divider />
  </v-item-group>
</template>
<script>
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";

const modalityType = [
  {
    title: "Modalidade",
    id: 0
  },
  {
    title: "Trabalhista",
    id: 1
  },
  {
    title: "Financeiro",
    id: 2
  }
];
export default {
  data: () => ({
    list1: modalityType
  }),
  components: {
    QuotationCard: CardDescriptionButton
  },
  computed: {
    listActiveModality() {
      return this.list.filter(x => x.ativo == true);
    }
  },
  methods: {
    selectedItem(item) {
      this.$emit("modality", item);
    },
    findActiveItem(item) {
      return this.model ? item.id === this.model.id : false;
    }
  },
  props: {
    model: {
      type: Object
    },
    list: {
      type: Array
    },
    title: {
      type : String,
      default : ()=>("MODALIDADE")
    }
  }
};
</script>
<style lang="sass" scoped></style>
